import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfBrush,
  PdfFont,
  ETextAlign,
} from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { IItemCount } from '@educraft/base';
import { OptsImage } from '../optsImage';
import { GUtil } from '../../pdf/gutil';
import { calcOrigin } from '../../core/genHelper';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/shapes';

/**
 * Pocty__1 (Counting 1) - Visual counting with dice representation
 *
 * Layout: 1 portrait page, 2×5 grid.
 * Each cell shows a number (1-10) as: digit, repeated images, and dice faces.
 *
 * Migrated from C# EduFrame.Img10.Generators.Pocty__1
 */
export class Pocty__1 implements ILayoutImageGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 2;
  }
  countMax(): number {
    return 12;
  }
  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const diceMargin = PdfUnit.FromMillimeters(3);
    const rows = Math.ceil(opts.list.length / 2);
    const { origin, size } = calcOrigin(2, rows, margin, PdfSize.A4);
    const space = PdfUnit.FromMillimeters(20);

    const page = pdf.addPage();
    const font = new PdfFont(PdfFont.FONT_NAME, 36);

    for (let x = 0; x < 2; x++) {
      for (let y = 0; y < rows; y++) {
        const rect = new PdfRect(
          origin.x + x * size.width,
          origin.y + y * size.height,
          size.width,
          size.height
        );
        const imageRect = new PdfRect(
          rect.x + space,
          rect.y,
          rect.width - space - space,
          rect.height
        );
        const numberRect = new PdfRect(rect.x, rect.y + diceMargin, space, rect.height);
        const diceRect = new PdfRect(
          imageRect.right + diceMargin,
          imageRect.y + diceMargin,
          space - 2 * diceMargin,
          rect.height - 2 * diceMargin
        );

        const index = y * 2 + x;
        let count = index + 1;
        const dices: number[] = [];

        if (index >= opts.list.length) {
          continue;
        }

        if (count > 6) {
          dices.push(6);
          count -= 6;
        }
        dices.push(count);

        const { cx, cy } = this.calcSize(index + 1);
        const s = { width: imageRect.width / cx, height: imageRect.height / cy };

        for (let x1 = 0; x1 < cx; x1++) {
          for (let y1 = 0; y1 < cy; y1++) {
            if (y1 * cx + x1 <= index) {
              const r = new PdfRect(
                imageRect.x + s.width * x1,
                imageRect.y + s.height * y1,
                s.width,
                s.height
              );
              if (index < opts.list.length) {
                page.drawImageCenter(opts.list[index].image, r);
              }
            }
          }
        }

        page.drawDicesV(GUtil.basePen, diceRect, diceMargin, ...dices);
        page.drawString(`${index + 1}`, font, PdfBrush.Black, null, numberRect, ETextAlign.Center);
        page.drawRectangle(GUtil.basePen, null, rect);
      }
    }
  }

  private calcSize(num: number): { cx: number; cy: number } {
    const cx = Math.ceil(Math.sqrt(num));
    const cy = Math.ceil(num / cx);
    return { cx, cy };
  }
}
